// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","container":"container--kmnMI","formItemCol":"formItemCol--3qMEK","labelInfo":"labelInfo--3xpxJ"};